import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CommonService } from './common.service';
import {MemoryStorageService} from './memory-storage.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private commonService: CommonService, private router: Router,private memorystore:MemoryStorageService) { }

  canActivate() {
    // if (this.commonService.getUserInfoFromLocalStorage('token') != null) {
    if (this.memorystore.getItem('token') != null) {
      return true;
    }
    else {
      this.router.navigate(["login"]);
      return false;
    }
  }
}
